import { TagManager } from '@navent-jobs/config'

export const DataLayer = {
  handlerShareAvisoTraking: (channel: string) => {
    /**
     * Debe ejecutarse cuando el usuario comparte un aviso
     */

    const channels = {
      WHATSAPP: 'Whatsapp',
      FACEBOOK: 'Facebook',
      TWITTER: 'Twitter',
      EMAIL: 'Email',
      COPY: 'Copiar enlace',
    }

    return TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Aviso',
      eventAction: 'Compartir Aviso',
      eventLabel: `CTA ${channels[channel]}`,
    })
  },
  handlerShareAvisoIntentionTraking: () => {
    /**
     * Debe ejecutarse cuando el usuario hace click en cta compartir
     */

    return TagManager.Push({
      event: 'trackEvent',
      eventCategory: 'Aviso',
      eventAction: 'Compartir Aviso',
      eventLabel: 'Intencion',
    })
  },
}
